import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { activityRoutes } from 'app/activity/routes/activity-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(activityRoutes)
  ],
  exports: [ RouterModule ]
})
export class ActivityRoutingModule { }
